/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Contract Signature Request Type
 */
export type TContractSignatureRequest = {
    signedDate: string;
    user_id: string;
    consentToESign: boolean;
    base64signatureImage: string;
    name: string;
    field: TContractSignatureRequest.field;
};
export namespace TContractSignatureRequest {
    export enum field {
        PERFORMER_SIGNATURE = 'performerSignature',
        PRODUCER_SIGNATURE = 'producerSignature',
        PERFORMER_SPECIAL_PROVISIONS_SIGNATURE = 'performerSpecialProvisionsSignature',
    }
}

